import * as actiontypes from '../../constants/actionType';

export function setReportProtocolName(protocolName) {
  return (dispatch) => {
    dispatch({type: actiontypes.SET_REPORT_PROTOCOL_NAME, protocolName});
  };
}

export function setReportProtocolOwner(protocolOwner) {
  return (dispatch) => {
    dispatch({type: actiontypes.SET_REPORT_PROTOCOL_OWNER, protocolOwner});
  };
}

export function setReportProtocolRunBy(protocolRunBy) {
  return (dispatch) => {
    dispatch({type: actiontypes.SET_REPORT_PROTOCOL_RUN_BY, protocolRunBy});
  };
}

export function setReportSummary(summary) {
  return (dispatch) => {
    dispatch({type: actiontypes.SET_REPORT_SUMMARY, summary});
  };
}

export function setReportSummaryCsv(summary) {
  return (dispatch) => {
    dispatch({type: actiontypes.SET_REPORT_SUMMARY_CSV, summary});
  };
}

export function setReportCreatedTime(createdTime) {
  return (dispatch) => {
    dispatch({type: actiontypes.SET_REPORT_CREATED_TIME, createdTime});
  };
}

export function restoreReport(state) {
  return (dispatch) => {
    dispatch({type: actiontypes.RESTORE_REPORT_SUMMARY, state});
  };
}

export function setReportId(id) {
  return (dispatch) => {
    dispatch({type: actiontypes.RESTORE_REPORT_ID, id});
  };
}

export function setPreviousReport(report) {
  return (dispatch) => {
    dispatch({type: actiontypes.SET_PREVIOUS_REPORT, report});
  };
}
